export const shouldShowOvernightToggle = (isEditing: boolean) => isEditing;
